const en_messages = require('./en/messages.json')

const ENGLISH_STRINGS = {
  translation: en_messages
}

export default ENGLISH_STRINGS
